export default __webpack_public_path__ + "static/truegrit-prize@2x-976ccaef3aae1e78b3c2c29501a1f2bb.png";